// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as AuthActions } from '../../../../auth/duck';
import type { RootState } from '../../../../index';
import FacebookNeedMail from '../component/FacebookNeedMail';

function mapStateToProps(state: RootState) {
  return {
    isAuthing: state.auth.isAuthing,
    authError: state.auth.authError,
    authenticated: state.auth.authenticated,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators(AuthActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FacebookNeedMail);



// WEBPACK FOOTER //
// ./src/modules/auth/auth-modals/facebook-need-email/container/FacebookNeedMailContainer.js